import React from 'react';
import CopyButton from '../components/CopyButton.jsx';
import { content } from '../config/site.js';

export default function Connect({ lang }) {
  const t = content[lang];

  return (
    <section className="section split reveal" id="connect">
      <div className="section-heading">
        <span className="section-label">{t.connect.label}</span>
        <h2>{t.connect.title}</h2>
        <p>{t.connect.text}</p>
        <div className="ip-panel">
          <span>{t.common.serverIp}</span>
          <CopyButton compact copiedText={t.common.copied} />
        </div>
      </div>

      <div className="step-list">
        {t.connect.steps.map((step) => (
          <article className="step-row reveal reveal-child" key={step.number}>
            <b>{step.number}</b>
            <div>
              <h3>{step.title}</h3>
              <p>{step.text}</p>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}
